import React, { FunctionComponent } from "react";
import styles from "./Footer.module.scss";
import FooterProps from "./Footer.interface";
import IconViewer from "components/IconViewer/IconViewer";
import Anchor from "components/Anchor/Anchor";

const Footer: FunctionComponent<FooterProps> = (props) => {
    return (
        <footer className={styles.wrapper}>
            {/* Columns */}
            <div className={styles.columns}>
                {props.settings?.footerColumns?.map((column: any, index: number) => {
                    return (
                        <div className={styles.column} key={column.contentUdi}>
                            <h4 className={styles.column_headline}>{column.content.headline}</h4>

                            {column.content.buttons && column.content.buttons?.map((button: any, bIndex: number) => {
                                return (
                                    <Anchor key={bIndex} to={button.content.link} className={styles.column_button}>{button.content.label}</Anchor>
                                );
                            })}
                        </div>
                    );
                })}
            </div>

            <div className={styles.bottom}>
                {/* Links */}
                <div className={styles.links}>
                    {props.settings?.footerLinks?.map((link: any, lIndex: number) => {
                        return (
                            <Anchor key={lIndex} to={link.content.link} className={styles.link_button}>{link.content.label}</Anchor>
                        );
                    })}
                </div>

                {/* Social */}
                <div className={styles.social}>
                    {/* Facebook */}
                    {props.settings?.socialFacebookUrl ? (
                        <Anchor aria="Facebook" className={styles.social_link} to={props.settings?.socialFacebookUrl}>
                            <IconViewer name="facebook" />
                        </Anchor>
                    ) : null}

                    {/* Instagram */}
                    {props.settings?.socialInstagramUrl ? (
                        <Anchor aria="Instagram" className={styles.social_link} to={props.settings?.socialInstagramUrl}>
                            <IconViewer name="instagram" />
                        </Anchor>
                    ) : null}

                    {/* LinkedIn */}
                    {props.settings?.socialLinkedinUrl ? (
                        <Anchor aria="LinkedIn" className={styles.social_link} to={props.settings?.socialLinkedinUrl}>
                            <IconViewer name="linkedin" />
                        </Anchor>
                    ) : null}

                    {/* Twitter */}
                    {props.settings?.socialTwitterUrl ? (
                        <Anchor aria="Twitter" className={styles.social_link} to={props.settings?.socialTwitterUrl}>
                            <IconViewer name="twitter" />
                        </Anchor>
                    ) : null}

                    {/* YouTube */}
                    {props.settings?.socialYoutubeUrl ? (
                        <Anchor aria="Youtube" className={styles.social_link} to={props.settings?.socialYoutubeUrl}>
                            <IconViewer name="youtube" />
                        </Anchor>
                    ) : null}
                </div>
            </div>
        </footer>
    );
};

export default Footer;